module.exports = __webpack_public_path__ + "img/banner_dummy_riding.84baecf4.png";